import Api from "./request"
import Const from "../js/const"

const apiList = {
    // 总揽
    Stat: {
        deviceNum: ["stat/device"]
    },
    Cache: {
        clear: ["cache/addr/clear"/* , "space", "uid" */],
    },
    // 管理员
    Admin: {
        login: ["admin/login"/* , "username", "password" */],

        list: ["admin/list"/* , "username", "page" */],
        save: ["admin/save"/* , "id", "username", "password", "config" */],
        detail: ["admin/detail"/* , "id" */],
        delete: ["admin/delete"/* , "id" */],
        updatePassword: ["admin/update-password"/* , "old_password", "new_password" */], // 更改自己的密码
        updatePwd: ["admin/update-pwd"/*, "user_id", "new_password" */], // 更改别人的密码
    },
    // 用户
    User: {
        login: ["user/login"/* , "username", "password" */],

        list: ["user/list"/* , "username", "page" */],
        listAll: ["user/all-list"/* , "username" */],
        save: ["user/save"/* , "username", "password" */],
        update: ["user/update"/* , "user_id", "notify_url", "addr_profile", "addr_config", "addr_extra" */],
        delete: ["user/delete"/* , "user_id" */],
        detail: ["user/detail"/* , "user_id" */],

        setNotifyUrl: ["user/set-notify-url"/* , "notify_url" */],
    },
    Export: {
        export26005: ["device/26005/export-device"/* , "space", "uid", "status"  ["user_id", "channel", "agent_id"]  {"version" , "dtu_software_version", "begin_time", "end_time", "sort", "order"} */],
        taskImport: ["ota-task-member/download-import-template"],
    },

    Device: {
        allotUserList: ["device/find-device-user"/* , "device_id" */],

        eventList: ["device-event/list-by-space-uid"/* , "space", "uid", "page" */],
        relayLog: ["relay-log/list"/* , "page", "space", "device_uid", "begin_time", "end_time" */],
    },

    Vehicle: {
        list: ["device/vehicle/list"/* , "space", "uid", "user_id", "status",  "channel", "page", "agent_id" */],
        save: ["device/vehicle/simple-save"/* , "vehicle_id", "space", "uid", "imei" */],

        detail: ["device/vehicle/detail"/* , "uid" */],
        detailByUid: ["device/vehicle/detail-by-uid"/* , "uid" */],

        distribute26001: ["device/26001/vehicle/distribute"/*, "vehicle_id", "user_id"*/],
        distribute26003: ["device/26003/vehicle/distribute"/*, "vehicle_id", "user_id"*/],
        distribute26005: ["device/26005/vehicle/distribute"/*, "vehicle_id", "user_id"*/],
        distribute26006: ["device/26006/vehicle/distribute"/*, "vehicle_id", "user_id"*/],
    },

    Battery: {
        list: ["device/battery/list"/* page space uid user_id status dtu_software_version begin_time end_time */],
        // export26005: ["device/26005/export-device"/* , "space", "uid", "status"  ["user_id"]  {"version" , "dtu_software_version", "begin_time", "end_time", "sort", "order"} */],
        save: ["device/battery/simple-save"/* , "vehicle_id", "space", "uid", "imei" */],

        detail: ["device/battery/detail"/* , "uid" */],
        detailByUid: ["device/battery/detail-by-uid"/* , "uid" */],

        distribute26005: ["device/26005/battery/distribute"/*, "vehicle_id", "user_id"*/],
        distribute26006: ["device/26006/battery/distribute"/*, "vehicle_id", "user_id"*/],
    },

    Fengine26001: {
        getFrameList: ["fengine/26001/frame-list"/* , "id", "page", "begin_time", "end_time" */],
        getCommandList: ["fengine/26001/command/list"/* , "page", "id" */],

        sendCmd: ["fengine/26001/cmd/send"/* , "id", "cmd" */],
    },

    Fengine26003: {
        getFrameList: ["fengine/26003/frame-list"/* , "id", "page", "begin_time", "end_time" */],
        getCommandList: ["fengine/26003/command/list"/* , "page", "id" */],

        //sendCmd
        launch: ["fengine/26003/cmd/launch"/* , "id", "launch_status" */], // 启动点火
        reboot: ["fengine/26003/cmd/reboot"/* , "id" */], // 重启
        check: ["fengine/26003/cmd/check"/* , "id" */], // 检测

        getGsmGpsStatus: ["fengine/26003/cmd/get-gsm-gps-status"/* , "id" */], // 查询GSM/GPS状态
        getLocation: ["fengine/26003/cmd/get-location"/* , "id" */], // 获取位置
        getHistoryLocation: ["fengine/26003/cmd/get-history-location"/* , "id" */], // 获取历史位置
        getBattery: ["fengine/26003/cmd/get-battery"/* , "id" */], // 获取电池状态

        setBMS: ["fengine/26003/cmd/set-bms"/* , "id", "index", "config", "timeout" */], // 设置BMS信息
        setServerAddr: ["fengine/26003/cmd/set-server-addr"/* , "id", "addr" */], // 设置服务端地址

        getGuard: ["fengine/26003/cmd/get-guard"/* , "id" */], // 获取设防状态
        setGuard: ["fengine/26003/cmd/set-guard"/* , "id", "guard_status" */], // 设置设防状态

        getLock: ["fengine/26003/cmd/get-lock-status"/* , "id" */], // 获取锁状态
        setLock: ["fengine/26003/cmd/set-lock"/* , "id", "lock_status" */], // 设置锁车状态

        getHeartbeatInterval: ["fengine/26003/cmd/get-heartbeat-interval"/* , "id" */], // 获取心跳间隔
        setHeartbeatInterval: ["fengine/26003/cmd/set-heartbeat-interval"/* , "id", "heartbeat_interval" */], // 设置心跳间隔

        getAPN: ["fengine/26003/cmd/get-apn"/* , "id" */], // 获取APN
        setAPN: ["fengine/26003/cmd/set-apn"/* , "id", "apn" */], // 设置APN

        getLocateInterval: ["fengine/26003/cmd/get-locate-interval"/* , "id" */], // 获取定位周期
        setLocateInterval: ["fengine/26003/cmd/set-locate-interval"/* , "id", "acc_on_interval", "acc_off_interval" */], // 设置定位周期

        getModuleInfo: ["fengine/26003/cmd/get-module-info"/* , "id", */], // 获取部件信息
        getMileage: ["fengine/26003/cmd/get-mileage"/* , "id", */], // 获取里程 

        setHmiParams: ["fengine/26003/cmd/set-hmi-params"/* id rear_wheel_speed_ratio front_wheel_speed_ratio drive_ratio remaining_mileage_ratio*/], // 设置HMI参数
        setBmsParams: ["fengine/26003/cmd/set-bms-params"/* id cut_off_voltage_threshold over_voltage_protect_threshold over_current_protect_threshold */], // 设置BMS参数
        setMcuParams: ["fengine/26003/cmd/set-mcu-params"/* id leak_voltage_protect_threshold over_current_protect_threshold over_voltage_protect_threshold motor_pole_pair_count reverse_charge_current*/], // 设置MCU参数
    },

    Fengine26005: {
        getFrameList: ["fengine/26005/frame-list"/* , "id", "page", "begin_time", "end_time" */],
        getCommandList: ["fengine/26005/command/list"/* , "page", "id" */],

        // sendCmd:  ["fengine/26005/cmd/send"/* , "id", "cmd" */],
        sendCmd:  ["fengine/26005/cmd/write"/* , "id", "bkv" */],
        getInfo1: ["fengine/26005/cmd/write/get-info-1"/* , "id" */],
        getInfo2: ["fengine/26005/cmd/write/get-info-2"/* , "id" */],
        getInfo3: ["fengine/26005/cmd/write/get-info-3"/* , "id" */],
    },

    Fengine26006: {
        getFrameList: ["fengine/26006/frame-list"/* , "id", "page", "begin_time", "end_time" */],
        getCommandList: ["fengine/26006/command/list"/* , "page", "id" */],

        // sendCmd:  ["fengine/26006/cmd/send"/* , "id", "cmd" */],
        sendCmd:  ["fengine/26006/cmd/write"/* , "id", "bkv" */],
        getInfo1: ["fengine/26006/cmd/write/get-info-1"/* , "id" */],
        getInfo2: ["fengine/26006/cmd/write/get-info-2"/* , "id" */],
        getInfo3: ["fengine/26006/cmd/write/get-info-3"/* , "id" */],
    },

    Fengine26007: {
        getFrameList: ["fengine/26007/frame-list"/* , "id", "page", "begin_time", "end_time" */],
        getCommandList: ["fengine/26007/command/list"/* , "page", "id" */],
    },

    OtaTask: {
        list: ["ota-task/list"/* , "page", "space" */],
        create: ["ota-task/create"/* , "space", "name", "target_version", "begin_time", "end_time" */],
        detail: ["ota-task/detail"/* , "task_id" */],
        delete: ["ota-task/delete"/* , "task_id" */],

        start: ["ota-task/start"/* , "task_id" */],
        pause: ["ota-task/pause"/* , "task_id" */],
        stop: ["ota-task/stop"/* , "task_id" */],

        fileCreate: ["ota-file/save"/* , "id", "task_id", "name", "path", "version", "hash", "size" */],
        fileDetail: ["ota-file/detail"/* , "task_id" */],
    },
    OtaTaskMember: {
        list: ["ota-task-member/list"/* , "task_id", "status", "page" */],
        add: ["ota-task-member/add"/* , "task_id", "device_ids" */],

        quit: ["ota-task-member/quit"/* , "task_member_id" */],
        start: ["ota-task-member/start"/* , "task_member_id" */],
        delete: ["ota-task-member/delete"/* , "task_member_id" */],
    },
};

const api = Api(apiList, Const.NET.END_POINT)

export default api
